import { UIComponentHandler, UIComponentState, UIDataModel } from '../../../toolkit/uicomponent';
import { BaseContext } from '../../../../utils/basecontext';
import { UIComponentView } from '../../../toolkit/uicomponentview';
import { UIComponentCSSStyle } from '../../../toolkit/uicomponentcss';
import { SearchCSSStyleImpl } from './searchcss';
import { SearchAPIModelImpl, SearchAPIModel } from './searchapimodel';
import { APIFeatures } from '../../../../core/util/apifeatures';
import { APIModelHandler, APIModel } from '../../../toolkit/uicomponentapimodel';
import { SearchViewImpl } from './searchview';
import { SpecificSearchToneDto } from '../../../../core/dto/specificsearchtone/specificsearchtonedto';
import { CRBTUIComponentProps, CRBTUIComponent } from '../crbt/crbtuicomponent';

export interface SearchComponentProps extends CRBTUIComponentProps
{
   searchKey: string;
}

export interface SearchComponentState extends UIComponentState
{
    searchKey: string;
}
export interface SearchComponentHandler extends UIComponentHandler
{
    onLoadMore(startIndex: number, offset: number): void;
}

export interface SearchTabComponentHandler 
{
    onLoadMore(startIndex: number, offset: number): void;
}

export class SearchComponent extends CRBTUIComponent<SearchComponentProps, SearchComponentState> 
implements SearchComponentHandler
{
    private isLoadMore: boolean = false;
    constructor(props: SearchComponentProps)
    {
        super(props);

        this.state = {searchKey: props.searchKey};

        this.onLoadMore = this.onLoadMore.bind(this);
    }
   
    protected createComponentView(applicationContext: BaseContext, uiComponentHandler: UIComponentHandler): UIComponentView<UIDataModel>
    {
        return new SearchViewImpl(+this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), applicationContext, uiComponentHandler);
    }

    UNSAFE_componentWillMount()
    {
        super.UNSAFE_componentWillMount();

        (this.getAPIModel() as SearchAPIModel).loadMore(0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), this.props.searchKey);
    }

    protected createComponentCSS(applicationContext: BaseContext): UIComponentCSSStyle
    {
        return new SearchCSSStyleImpl(applicationContext);
    }
    
    protected createAPIModel(applicationContext: BaseContext, apiModelHandler: APIModelHandler): APIModel
    {
         return new SearchAPIModelImpl(applicationContext, apiModelHandler);
    }

    componentWillReceiveProps(nextProps: SearchComponentProps)
    {
       this.setState({searchKey: nextProps.searchKey});

       this.isLoadMore = false;
    //    (this.getView() as SearchViewImpl).resetPaginationState();
       
       (this.getAPIModel() as SearchAPIModel).loadMore(0, +this.props.context.getConfigurationSettings().getProperty("FETCH_LIMIT"), nextProps.searchKey);
    }

    onLoadMore(startIndex: number, offset: number): void 
    {
        this.isLoadMore = true;
        (this.getAPIModel() as SearchAPIModel).loadMore(startIndex, offset, this.state.searchKey);
    }

    onSuccess(feature: APIFeatures, description: string, data: any): void 
    {
        if(feature === APIFeatures.SPECIFIC_SEARCH_TONE)
        {
            if(!this.isLoadMore)
            {
                console.log("onsuccess normal load");
                (this.getView() as SearchViewImpl).updateTabData((data as SpecificSearchToneDto));
            }
            else
            {
                (this.getView() as SearchViewImpl).updateLoadMoreData((data as SpecificSearchToneDto));
            }

            // this.forceUpdateComponent();
        }
        // else
        // {
        //     (this.getView() as SearchViewImpl).updateTabData(data as ToneDto[]);
        // }
    }
}


// WEBPACK FOOTER //
// ./src/com/sixdee/crbtportal/ui/components/home/search/searchcomponent.tsx